import { config } from '../config';
import { makeApiRequest_AppJson } from './common-apiService';

export const getMicroservices = async (accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/system/discovery/apps`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
        Accept: 'application/json', // Request JSON response
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}